const loadingSpinner = /*html*/ `
<div class="flex items-center justify-center p-12">
<svg class="animate-spin size-8 text-secondary-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
</svg>
</div>`

document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.quicklook-btn')
    const modal = document.querySelector('[data-modal_id="quicklook"]')
    const contentArea = modal?.querySelector('.quicklook-content-area')
    if (!btn || !modal || !contentArea) return

    const productId = btn.dataset.productId
    if (!productId) return

    // Reset to loading state (modal opens via existing modal system through data-toggle_modal)
    contentArea.innerHTML = loadingSpinner

    try {
        const formData = new FormData()
        formData.append('action', 'lw_product_quicklook')
        formData.append('product_id', productId)

        const res = await fetch(liGlobal.ajaxUrl, { method: 'POST', body: formData })
        const data = await res.json()

        if (data.success && data.data.html) {
            contentArea.innerHTML = data.data.html
        } else {
            contentArea.innerHTML = '<p class="p-8 text-center text-secondary-500">Kunde inte ladda produkten.</p>'
        }
    } catch {
        contentArea.innerHTML = '<p class="p-8 text-center text-secondary-500">Kunde inte ladda produkten.</p>'
    }
})
